import { IStudyResultForGrid } from 'modules/Search/_types';
import { useAppGlobals } from './useAppGlobals';
import { compact, get, isArray, sortBy, uniq } from 'lodash';
import { getDocumentsByTags } from 'modules/ClinicalPortal/Patient/_api';
import { useLanguage } from './useLanguage';

export const useSubmitDocumentsByTagForm = (
  setRows: React.Dispatch<React.SetStateAction<IStudyResultForGrid[]>>,
  setUniqTypes: React.Dispatch<React.SetStateAction<string[]>>,
) => {
  const { toggleLoader } = useAppGlobals();
  const { currentLocale } = useLanguage();

  const onSubmitDocumentsByTagForm = async (values: any) => {
    setRows([]);
    setUniqTypes([]);
    toggleLoader();
    await getDocumentsByTags(values).then((resp) => {
      let allTypes: string[] = [];
      if (isArray(resp)) {
        const rows: IStudyResultForGrid[] = [
          ...resp.map((item) => {
            const typeOfDocumentName = get(item, 'typeOfDocument.translateJson')
              ? get(
                  JSON.parse(get(item, 'typeOfDocument.translateJson')),
                  currentLocale,
                  get(item, 'typeOfDocument.name'),
                )
              : '?';
            allTypes.push(typeOfDocumentName);
            return {
              ...item,
              typeOfDocumentName,
            };
          }),
        ];
        setRows(rows);
        setUniqTypes(sortBy(uniq(compact(allTypes)).map((type) => type.toString())));
      }
    });
    toggleLoader(false);
  };
  return { onSubmitDocumentsByTagForm };
};
